// extracted by mini-css-extract-plugin
export var active = "_gz-1";
export var circle = "_gz-0";
export var completed = "_gz-2";
export var connector = "_gz-4";
export var connectorCompleted = "_gz-7";
export var connectorSpacer = "_gz-5";
export var iconStrokeOverride = "_gz-8";
export var labelContainer = "_gz-6";
export var pending = "_gz-3";